import { Accordion, Col, Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { fieldParams } from '@/common/person/personmodalfieldparams.js'
import EducationView from '@/mgmtview/competences/educations/index.jsx'
import CourseView from '@/mgmtview/competences/courses/index.jsx'
import SkillsView from '@/mgmtview/competences/skills/index.jsx'
import LanguagesView from '@/mgmtview/competences/languages/index.jsx'

const ExternalWorkforceCompetencesTab = ({ person, handleDetails, formErrors }) =>{
  const { t } = useTranslation()

  return (
    <>
      <Form.Group as={Col} xl={4} controlId="education" className="px-3 pt-3">
        <Form.Label>{t('EducationToSalaries', 'Koulutus-tieto palkanlaskentaan')}</Form.Label>
        <Form.Control
          onChange={handleDetails}
          defaultValue={person.details?.education}
          isInvalid={!!formErrors.education}
          maxLength={fieldParams.education?.maxLength}
        />
        <Form.Control.Feedback type="invalid">{formErrors.education}</Form.Control.Feedback>
      </Form.Group>
      <Accordion defaultActiveKey={['competence-1']} flush alwaysOpen>
        <Accordion.Item key="competence-1" eventKey="competence-1">
          <Accordion.Header>{t('Educations', 'Tutkinnot')}</Accordion.Header>
          <Accordion.Body className="d-flex flex-column h-450">
            <EducationView person={person} />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item key="competence-2" eventKey="competence-2">
          <Accordion.Header>{t('OtherEducation', 'Muu koulutus')}</Accordion.Header>
          <Accordion.Body className="d-flex flex-column h-450">
            <CourseView person={person} />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item key="competence-3" eventKey="competence-3">
          <Accordion.Header>{t('Skills', 'Taidot')}</Accordion.Header>
          <Accordion.Body className="d-flex flex-column h-450">
            <SkillsView person={person} />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item key="competence-4" eventKey="competence-4">
          <Accordion.Header>{t('Languages', 'Kielitaito')}</Accordion.Header>
          <Accordion.Body className="d-flex flex-column h-450">
            <LanguagesView person={person} />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  )
}

export default ExternalWorkforceCompetencesTab
